import { Link } from 'react-router';

import HomeOutlined from '@mui/icons-material/HomeOutlined';
import { Box } from '@mui/material';

import { HeaderIconButton } from 'components/header/HeaderIconButton';
import { MenuModules } from 'components/header/menu-modules/MenuModules';
import { MenuShortcuts } from 'components/header/menu-shortcuts/MenuShortcuts';
import { MenuSystem } from 'components/header/menu-system/MenuSystem';

/**
 * Cabeçalho padrão do sistema, geralmente fixo no topo da página
 * Contém botão home + menu principal (button e logo do cliente) + taskbar com ícones de ações + dados do cliente (nome e empresa) + menu do sistema
 */
export function Header() {
    return (
        <Box
            component="header"
            sx={{
                height: 60,
                p: 1.25,
                gap: 1.25,
                display: 'flex',
                alignItems: 'center',
                backgroundColor: 'secondary.main',
            }}
        >
            <HeaderIconButton component={Link} to="/">
                <HomeOutlined />
            </HeaderIconButton>

            <MenuModules />

            <MenuShortcuts />

            <MenuSystem />
        </Box>
    );
}
